// @ts-strict-ignore
import { ArticleLocationVO } from '@article/model/vo/article-location.vo';

export class ReplaceReferenceArticleLocationVO extends ArticleLocationVO {

  public articleUsageIdToReplace: string;
  public rotationAngle: number;
  public detachReplacedArticle: boolean = true;

  public constructor() {
    super();
  }
}
